export default __webpack_public_path__ + "static/media/webtable2.5caef62a.png";